import React from "react";
import { Button, Card, Progress, Tag, Typography,Image } from "antd";
import { getImageUrl } from "../api";
import { CLOTHING_CATEGORY } from "../constants";
import { stockPercent } from "../utils";
import ProductBadges from "./ProductBadges";

const { Meta } = Card;
const { Text } = Typography;

export default function ProductCard({ product, onSelect }) {
  const outOfStock = product.stock <= 0;

  return (
    <Card
      hoverable
      style={{
        borderRadius: 12,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
      bodyStyle={{ padding: 12 }}
      cover={
       
          <Image
            alt={product.name}
            src={getImageUrl(product.image)}
            onError={(e) => {
              e.currentTarget.src = `${getImageUrl("images/default.png")}`;
            }}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        
      }
    >
      <Meta
        title={<span style={{ fontSize: 15 }}>{product.name}</span>}
        description={
          <Text
            type="secondary"
            style={{ fontSize: 12 }}
            ellipsis={{ tooltip: product.description }}
          >
            {product.description}
          </Text>
        }
      />

      {product.category === CLOTHING_CATEGORY && <ProductBadges product={product} />}

      <div style={{ marginTop: 10 }}>
        <Tag color="blue">Stock: {product.stock}</Tag>
        <Progress
          percent={stockPercent(product.stock, product.max_stock)}
          size="small"
          status={outOfStock ? "exception" : "active"}
          showInfo={false}
          style={{ marginTop: 6 }}
        />
      </div>

      <div style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 4 }}>
        <Tag color="gold">{product.price} Bravos</Tag>
        <Tag color="volcano">${product.cash} MXN</Tag>
        <Tag color={product.is_colective ? "purple" : "green"}>
          {product.is_colective ? "Colectivo" : "Individual"}
        </Tag>
        {product.popular && <Tag color="orange">🔥 Popular</Tag>}
        {outOfStock && <Tag color="red">Agotado</Tag>}
      </div>

      <Button
        type="primary"
        block
        size="large"
        style={{
          marginTop: 12,
          borderRadius: 6,
          backgroundColor: "#fadb14",
          borderColor: "#fadb14",
          color: "#333",
          fontWeight: "bold",
        }}
        disabled={outOfStock}
        onClick={() => onSelect(product)}
      >
        Canjear
      </Button>
    </Card>
  );
}
